exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.section-box[data-v-0e4d8af4] {\n  height: 600px;\n  text-align: center;\n}\n.section-box > div[data-v-0e4d8af4] {\n    margin-bottom: 20px;\n}\n.slogn[data-v-0e4d8af4] {\n  text-align: center;\n  font-size: 0;\n}\n.slogn .logo-box[data-v-0e4d8af4] {\n    margin: 10px auto;\n    width: 200px;\n    margin-bottom: 20px;\n}\n.slogn img[data-v-0e4d8af4] {\n    width: 100%;\n}\n.slogn h3[data-v-0e4d8af4], .slogn span[data-v-0e4d8af4] {\n    display: inline-block;\n    vertical-align: middle;\n    line-height: 1;\n    font-size: 22px;\n}\n.desc[data-v-0e4d8af4] {\n  margin-top: 10px;\n  color: #999;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-0e4d8af4","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/sass-resources-loader/lib/loader.js?{"resources":["/root/workspace/platform-admin_Cbe5/src/style/theme.scss","/root/workspace/platform-admin_Cbe5/src/style/_mixin.scss"]}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/view/base/asset/accountactivation/index.vue
// module id = 893
// module chunks = 30